/**
 * Warms up the browser's HTTP cache for a set of image URLs.
 *
 * Fire-and-forget: returns immediately. The browser dedups in-flight requests
 * to the same URL, so calling this before Fabric's loadFromJSON makes the
 * subsequent fetches resolve from cache.
 *
 * `crossOrigin = 'anonymous'` is critical: HTTP cache entries are partitioned
 * by request mode. Without it, the cached entry won't match what Fabric asks
 * for (Fabric uses anonymous CORS).
 */
export function preloadImages(urls: readonly string[]): void {
  const seen = new Set<string>();
  for (let i = 0; i < urls.length; i++) {
    const url = urls[i];
    if (!url || seen.has(url)) continue;
    seen.add(url);
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.decoding = 'async';
    img.src = url;
  }
}
